import {Component, OnInit} from '@angular/core';
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss', '../layout/landing-layout.component.scss']
})
export class HomeComponent implements OnInit {

  userIsLoggedIn: boolean;

  constructor(private title: Title) {
  }

  ngOnInit() {
    this.userIsLoggedIn = !!localStorage.getItem('token');
    this.title.setTitle('Home - Talespinner.io | AI-Powered Storytelling Platform');
  }

}
